module.exports = __webpack_public_path__ + "img/logo-promentesana.a6095055.svg";